import React, { Fragment } from 'react';
import { List, Datagrid, TextField, Filter } from 'react-admin';
import { DateInput } from 'react-admin-date-inputs';
import moment from 'moment';
import ExportButton from './reports/ExportButton';
import SendButton from './reports/SendButton';
import { CustomPagination } from './utils';

const AgentReportsFilter = props => {
    return (
        <Filter {...props}>
            <DateInput
                label="C"
                source="start_date"
                options={{ format: 'dd.MM.YYYY' }}
                isRequired={false}
                alwaysOn
            />
            <DateInput
                label="До"
                source="end_date"
                options={{ format: 'dd.MM.YYYY' }}
                isRequired={false}
                alwaysOn
            />
        </Filter>
    );
};

const BulkActionButtons = props => (
    <Fragment>
        <ExportButton
            label="Экспортировать"
            {...props}
        />
        <SendButton
            label="Отправить"
            {...props}
        />
    </Fragment>
);

export const AgentReportsList = props => (
    <List
        {...props}
        filters={<AgentReportsFilter />}
        // pagination={false}
        pagination={<CustomPagination />}
        exporter={false}
        filterDefaultValues={{
            start_date: moment().startOf('month').toDate(),
            end_date: moment().startOf('day').toDate(),
        }}
        bulkActionButtons={<BulkActionButtons />}
    >
        <Datagrid rowClick="edit">
            <TextField
                label="Id агента"
                source="id"
            />
            <TextField
                label="Имя агента"
                source="name"
            />
            <TextField
                label="Выручка"
                source="revenue"
            />
            <TextField
                label="Комиссия"
                source="commission"
            />
        </Datagrid>
    </List>
);
